import React from 'react';
import { colorForCategory, eventDisplayTitle } from './constants';
import { eventColorClassAndStyle } from '../planning/colorUtils';
import { useTranslation } from 'react-i18next';

export default function EventChip({
  event,
  isDragging,
  draggable = true,
  onClick,
  onContextMenu,
  onDragStart,
  onDragEnd,
}) {
  const { t } = useTranslation('planning');
  const color = colorForCategory(event.category);
  const colorMeta = eventColorClassAndStyle(color);
  const title = eventDisplayTitle(event);
  const start = event.start || '';
  const end = event.end || '';
  const timeRange = start && end ? `${start} – ${end}` : start || end;
  const isMultiDay = !!event.isMultiDay;
  const spanRange =
    isMultiDay && (event.rangeStart || event.date) && (event.rangeEnd || event.endDate)
      ? `${event.rangeStart || event.date} → ${event.rangeEnd || event.endDate}`
      : '';
  const tipParts = [
    title,
    timeRange,
    isMultiDay ? `${t('multiDayEvent')}${spanRange ? ` · ${spanRange}` : ''}` : null,
  ].filter(Boolean);
  const tip = tipParts.join(' · ');

  return (
    <div
      className={`month-event-chip ${colorMeta.className}${isDragging ? ' is-dragging' : ''}${
        !draggable ? ' is-readonly' : ''
      }${isMultiDay ? ' is-multi-day' : ''}${
        event.continuesFromPrev ? ' continues-prev' : ''
      }${event.continuesToNext ? ' continues-next' : ''}`}
      style={colorMeta.style}
      title={tip}
      draggable={draggable}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onDragStart={(e) => {
        if (!draggable) {
          e.preventDefault();
          return;
        }
        onDragStart?.(e);
      }}
      onDragEnd={onDragEnd}
    >
      {isMultiDay ? (
        <span className="month-event-multi-day" aria-label={t('multiDayEvent')}>
          <span className="material-symbols-outlined">date_range</span>
        </span>
      ) : null}
      {timeRange ? <span className="month-event-time">{timeRange}</span> : null}
      <span className="month-event-title">{title}</span>
    </div>
  );
}
